import React from "react";
import "../../../Styles/Upload.scss";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";
import { Image } from "../../../Models/Image";
import { ImagePreviewModal } from "../ImagePreviewModal";

type Props = {
  image: Image;
  onDelete: () => void;
};

type State = {
  showPreview: boolean;
};

export default class ImageUploadItem extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showPreview: false
    };
  }

  togglePreview = () => {
    this.setState(prevState => ({
      showPreview: !prevState.showPreview
    }));
  };

  onDeleteClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    event.stopPropagation();

    this.props.onDelete();
  };

  render() {
    return (
      <>
        <div className="gallery-item" onClick={this.togglePreview}>
          <img src={this.props.image.thumbnailUrl} alt="Unable to get image from server" />
          <a className="gallery-delete" onClick={this.onDeleteClick}>
            <span>
              <Icon
                appName="GeneralLayout"
                assetName="GENERAL_L_RemoveX"
                className={iconStyles.smallIcon}
              />
            </span>
          </a>
        </div>
        <ImagePreviewModal
          isOpen={this.state.showPreview}
          toggle={this.togglePreview}
          image={this.props.image}
        />
      </>
    );
  }
}
